import "./Styles/App.css";
import { Box } from "@chakra-ui/react";
import AllRoutes from "./component/AllRoutes"
function App() {
  return (
    <Box className="App" bg="#000000">
 <AllRoutes />
    </Box>
  );
}
export default App;
